var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.47L6 10V8L2 6.45L6 4.81V2.9L0 5.44V7.47ZM14 2.9V4.81L18 6.45L14 8.02V10.02L20 7.49V5.49L14 2.9ZM7.4 11.9L9.48 12.38L12.59 0.48L10.52 0L7.4 11.9Z",
    fill: "#0F1621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevConsole);
export default __webpack_public_path__ + "static/media/dev-console.e7611e4363a6d952dd67157363347f0b.svg";
export { ForwardRef as ReactComponent };